"use strict";

var e,
    t = require("react"),
    r = (e = require("url")) && "object" == typeof e && "default" in e ? e.default : e;

function o() {
  return (o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function n(e, t) {
  if (null == e) return {};
  var r,
      o,
      n = {},
      a = Object.keys(e);

  for (o = 0; o < a.length; o++) {
    t.indexOf(r = a[o]) >= 0 || (n[r] = e[r]);
  }

  return n;
}

function a(e) {
  return Object.entries(e).reduce(function (e, t) {
    var r = t[1];
    return void 0 !== r && (e[t[0]] = r), e;
  }, {});
}

function c(e) {
  if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(e)) throw new Error('Expected valid hex color, got "' + e + '"');
  return e.substring(1);
}

function l(e, t, o) {
  void 0 === o && (o = {});
  var n = o.backgroundColor,
      l = o.textColor,
      i = o.text;
  return r.format({
    protocol: "https",
    host: "via.placeholder.com",
    pathname: [e + "x" + t, n ? c(n) : "", l ? c(l) : void 0].filter(function (e) {
      return void 0 !== e;
    }).join("/"),
    query: a({
      text: i
    })
  });
}

function i(e, t, o) {
  void 0 === o && (o = {});
  var n = o.grayscale;
  return r.format({
    protocol: "https",
    host: "picsum.photos",
    pathname: "/" + e + "/" + t,
    query: a({
      grayscale: void 0 !== n && n || void 0,
      cacheId: (1e5 * Math.random()).toFixed(0)
    })
  });
}

exports.CustomPlaceholder = function (e) {
  var r = e.width,
      a = e.height,
      c = e.backgroundColor,
      i = e.textColor,
      u = e.text,
      h = e.src,
      s = n(e, ["width", "height", "backgroundColor", "textColor", "text", "src"]);
  return void 0 !== h && console.warn("Do not define the `src` prop for <CustomPlaceholder />; the src will be generated"), t.createElement("img", o({
    src: l(r, a, {
      backgroundColor: c,
      textColor: i,
      text: u
    }),
    alt: "placeholder"
  }, s));
}, exports.PhotoPlaceholder = function (e) {
  var r = e.width,
      a = e.height,
      c = e.grayscale,
      l = e.src,
      u = n(e, ["width", "height", "grayscale", "src"]);
  void 0 !== l && console.warn("Do not define the `src` prop for <PhotoPlaceholder />; the src will be generated");
  var h = t.useState(void 0),
      s = h[0],
      d = h[1];
  return t.useLayoutEffect(function () {
    d(i(r, a, {
      grayscale: c
    }));
  }, [r, a, c]), t.createElement("img", o({
    src: s,
    alt: "Placeholder"
  }, u));
}, exports.generateCustomPlaceholderURL = l, exports.generatePhotoPlaceholderURL = i;